/* EXC: hide reviewer names that are email addresses.
   Some Judge.me reviews were left with the buyer's email in the name field, and
   those render publicly in the carousels and the review list. Judge.me builds
   its widgets after page load and rebuilds them on paging and filtering, so
   this watches the document and re-checks on every change.
   The fix is cosmetic. Correct the names in the Judge.me admin. */
(function () {
  var SELECTORS = [
    '.jdgm-reviewer-name',
    '.jdgm-rev__author',
    '.jdgm-rev__buyer-name',
    '.jdgm-carousel-item__reviewer-name',
  ].join(',');

  function hideEmails(root) {
    var nodes = (root || document).querySelectorAll(SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      /* Judge.me fills these in after it renders, so re-read every pass
         instead of marking an element as checked once. */
      var isEmail = el.textContent.indexOf('@') !== -1;
      if (isEmail && el.style.display !== 'none') {
        el.style.setProperty('display', 'none', 'important');
      } else if (!isEmail && el.style.display === 'none') {
        el.style.removeProperty('display');
      }
    }
  }

  function start() {
    /* Reviewer names only appear inside Judge.me's review widgets and carousels
       (homepage and product pages, rendered by the app block as .jdgm-widget).
       Every page also carries a few .jdgm-star icons, so the check is on the
       widget. Without one there is nothing to hide, and watching the whole
       document cost about 150ms of phone CPU per page while apps load
       (PageSpeed, blog page, 2026-10-03). */
    if (!document.querySelector('.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-all-reviews-widget')) return;
    hideEmails(document);
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      /* setTimeout, not requestAnimationFrame: rAF is paused while the tab is
         in the background, and Judge.me renders whenever it finishes loading. */
      pending = setTimeout(function () {
        pending = null;
        hideEmails(document);
      }, 100);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
